module.exports = {
  // API_JARVIS: "https://api.celushop.com.ar/api/stark", // PRODUCCION
  API_JARVIS: "https://api.radarentacar.com.ar/api/stark", // PRODUCCION
  // DEV_URL: 'http://10.0.2.37', // DESARROLLO y PROD
  JARVIS_TOKEN:
    "Bearer RbTBOi6KLPL7dGh9GQ9LY3eajvYAdPOaEw4hBGhCdg5hi4DCATZKeLsm53B1B9xyzxriOOEGAfgPI8HAOMtS28CYy8MPFsKK05zpTyWjMOZ8GtxA3za0yp9FudiTQXU1GyqVctQvM7R6Sm1G11ytgcjTNvaNBUC5qbLlGDqxDFh2x6A8p5nT5S4DzUzyYv41SMYymZbs",
  PUBLIC_VAPID_KEY:
    'BPNGlWa5oj-5klgtgVA3xYNX__BikmcdaPyqJ55xEx8GFiZWkDmA1fBsPFC6LCL03IXIjRtqxp6u3qZj9fYWQIM',

 API_URL: process.env.VUE_APP_API_URL,
  // VUE_APP_API_URL se define por entorno en .env.development/.env.production
  // API_URL: 'https://jane-examines-cap-websites.trycloudflare.com/api' // DESARROLLO CLOUDFLARED, // build 18 de noviembre de 2025
};


//Horario de salida de taller:
// VIN
// COMENTARIO - AREA
// CORREO PARA JUJUY EN EL TURNERO
